export default class ArrivalAndDelivery {

    constructor() {

        this.notMeasured = 0;
        this.early = 0;
        this.onTime = 0;
        this.late = 0;
    }
}
